<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close(0)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 class="text-uppercase">{{'IDS_AUTO_RAISE' | translate}}</h4>
        <p>{{'IDS_AUTO_RAISE_TEXT' | translate}}</p>
    </div>
    <div class="mt-3">
        <form (ngSubmit)="makeAutoBid(bid)" #bid="ngForm">
            <div class="d-flex flex-column align-items-center">
                <label
                    [class.gold]="isMemorabid && !inPreEventStatus"
                    [class.marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.preEvent]="inPreEventStatus"
                    class="fw-bold pb-2">
                    {{'IDS_AMOUNT' | translate}}
                </label>
                <input
                    [class.input-auto-gold]="isMemorabid && !inPreEventStatus"
                    [class.input-auto-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.input-auto-preEvent]="inPreEventStatus"
                    type="text"
                    id="autoBid"
                    class="form-control"
                    ngModel
                    name="autoBid"
                    mask="separator.0"
                    thousandSeparator="."
                    suffix=" €"
                    required
                    pattern="^[1-9]+[0-9]*$">
                <label
                    *ngIf="showErrorString.length > 0"
                    class="error-label">
                    {{showErrorString | translate}}
                </label>
            </div>
            <div class="mt-3" *ngIf="inPreEventStatus">
                <small><b>{{'IDS_PRE_EVENT_AUCTION_REMINDER' | translate}}</b></small>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <button
                    type="submit"
                    [class.btn-gold]="isMemorabid && !inPreEventStatus"
                    [class.btn-marketplace]="!isMemorabid && !inPreEventStatus"
                    [class.btn-preEvent]="inPreEventStatus"
                    class="btn-dialog text-uppercase fw-bold px-3"
                    [disabled] = "!bid.valid || bid.value.autoBid < minimumOffer || bid.value.autoBid <= rebidMaxOfferPrice">
                    {{'IDS_ACTIVATE' | translate}}
                </button>
            </div>
            <div class="d-flex justify-content-center my-3">
                <button class="admin-new text-uppercase fw-bold px-3" [class.preEvent]="inPreEventStatus" type="button" (click)="activeModal.close(0)">
                    {{'IDS_BTN_ABORT' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>
